<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
      Author: Jose Martin de la Cruz Vicencio  - benkohanck
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

    <div class="data-list-container">
    <vx-card>
        <h2>Boletas de Calificaciones</h2>
        <div style="margin: 10px;">
            <!-- <p>{{cuatrimestre_ant[0].nombre}} {{cuatrimestre_ant[0].idAgno}}</p><br> -->
        </div>
        
    </vx-card>

        <vs-table style="margin: 40px;" :data="periodos_alumno">
            <template slot="thead">
                <vs-th>Número</vs-th>
                <!-- <vs-th>Materia</vs-th> -->
                <!-- <vs-th>Grupo</vs-th> -->
                <!-- <vs-th>Profesor</vs-th> -->
                <!-- <vs-th>Primer Parcial</vs-th> -->
              <!-- <vs-th>Segundo Parcial</vs-th> -->
              <!-- <vs-th>Ordinaria -(Promedio 1er y 2do parcial)</vs-th> -->
              <vs-th>Periodo</vs-th>
              <vs-th>Boleta</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                     <vs-td :data="data[indextr].id">
                 <!-- {{data[indextr].matricula}}-->
                  {{ indextr + 1 }}
                 </vs-td>
                    <!-- <vs-td :data="data[indextr].id">
                        {{data[indextr].nombre_materia}}
                    </vs-td> -->
                    <!-- <vs-td :data="data[indextr].id">
                          {{data[indextr].idCuatrimestre}}{{data[indextr].digito}}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                         {{data[indextr].apellidoPaterno}}   {{data[indextr].apellidoMaterno}}  {{data[indextr].nombres}}
                    </vs-td> -->

                    <!-- <vs-td :data="data[indextr].id">
                        {{data[indextr].calificacionPrimerParcial}}
                    </vs-td> -->
                  <!-- <vs-td :data="data[indextr].id">
                    {{data[indextr].calificacionSegundoParcial}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                   <div v-if="data[indextr].liberadaSegundoParcial">
                   {{data[indextr].calificacionFinal}}
                 </div>                      -->
                                  
                  <!-- </vs-td> -->
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].nom_periodo}}- {{data[indextr].idAgno}}
                  </vs-td>
                  <vs-td>
                    <!-- {{data[indextr].}} -->
                   <vs-button  @click="descargar_boleta(data[indextr].idAgno,data[indextr].idPeriodo)">Descargar Boleta (PDF)</vs-button>
                  </vs-td>

                </vs-tr>
            </template>
        </vs-table>
        <p></p>
    </div>
</template>

<script>
    import AddNewDataSidebar from './AddNewDataSidebar.vue';
    import vSelect from 'vue-select'
    import Button from "../components/vuesax/button/Button";
    export default {
        components: {
            Button,
            AddNewDataSidebar,
            'v-select': vSelect,
        },
        data() {
            return {
                matricula: localStorage.getItem('matricula'),
                // carrera: localStorage.getItem('id_carrera'),
                id : localStorage.getItem('id'),
                // alumno_detalle: [],
                // cuatrimestre_ant: [{ nombre: "", idAgno: "" }],
                periodos_alumno: [],
                itemsPerPage: 16,
                // isMounted: false,
            }
        },
        computed: {
            // currentPage() {
            //     if(this.isMounted && this.cargo_materias == 0) {
            //         //return this.$refs.table.currentx
            //     }
            //     return 0
            // },
        },
        methods: {

            // getCuatrimestreAnt(){
            //     this.$http.get("cuatrimestre_anterior").then(
            //         response => {
            //             // console.log(response.data)
            //             this.cuatrimestre_ant = response.data.cuatrimestre_ant;
            //             //console.log(this.kardex);
            //             //this.getCarreras();
            //             //
            //             //
            //             // this.traer_carga();
            //         },
            //         error => {
            //             this.StepError(error);
            //         }
            //     );
            // },
            get_periodos_alumno(){
                this.$http.get("catalogos/periodos_alumno/"+this.id).then(response => {
                        // console.log(response.data)
                        // this.materias = this.formatData(response.data.materias);
                        // console.log(this.alumno_detalle);

                        ////  this.materias = this.materias[10]
                        this.periodos_alumno = response.data.periodos_alumno;
                        this.$vs.loading.close();
                     //   this.getMateriasPosibles();

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },

            //  traer_carga(){
            //     this.$http.get("get_calificaciones_periodo/" + this.id + "/" + this.cuatrimestre_actual[0].idAgno + "/" + this.cuatrimestre_actual[0].idPeriodo).then(response => {
            //             // console.log(response.data)
            //             // this.materias = this.formatData(response.data.materias);
            //             // console.log(this.alumno_detalle);

            //             ////  this.materias = this.materias[10]
            //             this.carga_actual = response.data.calificaciones;
            //             this.$vs.loading.close();
            //          //   this.getMateriasPosibles();

            //         },
            //         error => {
            //             this.StepError(error);
            //         }
            //     );
            // },
 descargar_boleta(idAgno,idPeriodo){
// alert('descargar pdf boleta');
window.open('https://cdn.upbicentenario.edu.mx/api/descargar_boleta/' + this.id+'/'+idAgno+'/'+idPeriodo,'Boleta','');

// openPagina('https://cdn.upbicentenario.edu.mx/api/get_materias_alumno/' + this.id+'/'+this.cuatrimestre_actual[0].idAgno+'/'+this.cuatrimestre_actual[0].idPeriodo,'Carga Academica','800','600','');
            },

        },
        created() {
            this.$vs.loading();
            // this.carrera =  localStorage.getItem('id_carrera');
            // this.getCuatrimestreAnt();
            this.get_periodos_alumno();

        },
        mounted() {
            // this.isMounted = true;

        },

    }
</script>